export default "__VITE_ASSET__BTqtzozk__"